import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCreateJackpot = (params) => {
    return axios.post(`${backendHost}/api/admin/jackpot/create`, params);
};

export {
    postCreateJackpot
}